module.exports = __webpack_public_path__ + "img/20191016162852440.fa694ef0.jpg";